import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';

import { IPromoInfo } from 'shared/types/newbuildingPromos';

type TComponentPromo = IPromoModalProps['promo'];
type TComponentFeatures = IPromoModalProps['promo']['features'];
type TComponentLabels = IPromoModalProps['promo']['labels'];

export const preparePromo = (promo: IPromoInfo): TComponentPromo | null => {
  if (!promo) {
    return null;
  }

  return {
    authorName: `${promo.isFromBuilder ? 'Застройщик' : ''} ${promo.authorName}`.trim(),
    name: promo.name,
    type: promo.promoType,
    features: (promo.features as TComponentFeatures) || [],
    banks: promo.banks
      ? promo.banks.map(bank => ({
          id: bank.id,
          name: bank.name,
          logoUrl: bank.secondSquareImageUrl || bank.logoUrl || undefined,
        }))
      : [],
    cianMortgageBank: promo.bank && {
      id: promo.bank.id,
      name: promo.bank.name,
      logoUrl: promo.bank.secondSquareImageUrl || promo.bank.logoUrl || undefined,
      isPartner: Boolean(promo.bank.isPartner),
    },
    description: promo.description as string,
    availableJks: promo.availableJks || [],
    labels: promo.dialogLabels as TComponentLabels,
    fullCreditPriceTitle: promo.fullCreditPriceTitle,
    availablePurchaseTerms: promo.availablePurchaseTerms || [],
    mortgageLegalInfo: promo.promoLegalTerms,
  };
};
